import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'
import activities from './activities'

const state = {
  loading: true,
  error: null,
  candidate: {},
  activity_log: []
}

const actions = {
  fetch ({commit, state, dispatch}, data) {
    commit('fetch')
    return axios.get(`/1.0/admin/responses/${data.response_id}`)
      .then(response => {
        const resp = parseResponse(response).data[0]
        commit('fetchSuccess', {data: resp})
        
      })
      .catch(err => {
        const error = handleError(err)
        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  update ({commit, state, dispatch}, data) {
    commit('fetch')

    return axios.put(`/1.0/admin/candidate`, {
      candidate: [data]
    })
      .then(response => {
        const resp = parseResponse(response).data[0]

        return resp
      })
      .catch(err => {
        const error = handleError(err)

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  delete ({commit, state, dispatch}, data) {
    commit('fetch')

    return axios.delete(`/1.0/admin/responses/${data.id}`)
      .then(response => {
        const resp = parseResponse(response).data[0]

        return resp
      })
      .catch(err => {
        const error = handleError(err)

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  fullDelete ({commit, state, dispatch}, data) {
    commit('fetch')

    return axios.delete(`/1.0/admin/responses/${data.id}/full`)
      .then(response => {
        const resp = parseResponse(response).data[0]

        return resp
      })
      .catch(err => {
        const error = handleError(err)

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  get_activity_log ({commit, state, dispatch}, data) {
    commit('fetch')

    return axios.get(`/1.0/admin/responses/${data.response_id}/activity-log?count=100`)
      .then(response => {
        const log = parseResponse(response).data
        commit('activitySuccess', {data: log})
      })
      .catch(err => {
        const error = handleError(err)

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data}) {
    state.candidate = data
    state.loading = false
  },

  activitySuccess (state, {data}) {
    state.activity_log = data
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  clear (state) {
    state.candidate = {}
    state.activity_log = []
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },

  candidate: (state, getters) => {
    return state.candidate
  },

  activity_log: (state, getters) => {
    return state.activity_log
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    activities
  }
}
